import styled from 'styled-components'
import { Flex } from 'components'

export const Watermark = styled(Flex)`
  pointer-events: none;
  opacity: 0.25;
`
